import React from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick';
import WeImg from '../../assets/images/side_knife_img.png'
import WeIcon from '../../assets/images/knife_icon.png'
import Weimg from '../../assets/images/who_we.png'
import Wechef from '../../assets/images/who_chef.png'
import Wetext from '../../assets/images/who_text.png'
import gallery01 from '../../assets/images/gallery_01.png'
import gallery02 from '../../assets/images/gallery_02.png'
import gallery03 from '../../assets/images/gallery_03.png'
import gallery04 from '../../assets/images/gallery_04.png'
import gallery05 from '../../assets/images/gallery_05.png'
import gallery06 from '../../assets/images/gallery_06.png'
import gallery07 from '../../assets/images/gallery_07.png'
import gallery08 from '../../assets/images/gallery_08.png'
import Img11 from '../../assets/images/chef_cap.png'
import Img12 from '../../assets/images/chef_text.png'

const Whoslider = {
  infinite: true,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 10,
        autoplaySpeed: 2000,
        easing: "linear"
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 5,
        autoplaySpeed: 2000,
        easing: "linear"
      },
    },
  ],
}

function WhoWe() {
  return (
    <>
      <div className="row_am who_we_section bg_white_textcher">
        <div className="sider_shape" data-aos="fade-in" data-aos-duration={1500}>
          <img src={WeImg} alt="img" />
        </div>
        <div className="container">
          <div className="section_title d-flex justify-content-center align-items-start" data-aos="fade-up" data-aos-duration={1500} >
            <div className="icon">
              <img src={WeIcon} alt="img" />
            </div>
            <div className="text">
              <span className="sub_text">Who we are</span>
              <h2>
                Luxurious restaurant with A rare taste <br /> you can’t find anywhere.{" "}
              </h2>
            </div>
           
          </div>
          <div className="banner_badge">
                  <img className="img-fluid" src={Img11} alt="img" />
                  <div className="round_anim">
                    <img src={Img12} alt="img" />
                  </div>
            </div>
          <div className="row row_am">
            <div className="col-md-6">
              <div className="img" data-aos="fade-up" data-aos-duration={1500}>
                <img className="img-fluid radius_img" src={Weimg} alt="img" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="who_We_text">
                <p data-aos="fade-up" data-aos-duration={1500}>
                  Offering a unique dining experience, we offer our guests both fine food and excellent, warm service. 
               </p>
               
               <p data-aos="fade-up" data-aos-duration={1500}>Situated at the quiet end of Hisarönü on the way to Kaya Village, The Olive Tree is an extremely popular and well-regarded restaurant with many guests returning year after year. 
                </p>
                <p data-aos="fade-up" data-aos-duration={1500}>Our restaurant & bar are open to adults only.<em>(over 14)</em> Please book ahead to avoid disappointment.</p>
                <p data-aos="fade-up" data-aos-duration={1500}>
Kavımızdaki özel şaraplar ve fresh yaz kokteylleri gününüzü özel kılmak için sizleri bekliyor</p>
                <div className="chef_block d-flex justify-content-center align-items-center" data-aos="fade-up" data-aos-duration={1500} >
                  <img className="chef_img" src={Wechef} alt="img" />
{/*                   <img className="text_img" src={Wetext} alt="img" />
 */}                </div>
                <div className="action_block" data-aos="fade-up" data-aos-duration={1500} >
                  <ul className="social_media d-flex align-content-center">
                    <li>
                      <Link to="https://www.facebook.com/theolivetreerestaurantandbar">
                        <i className="icofont-facebook" />
                      </Link>
                    </li>
                   {/*  <li>
                      <Link to="#">
                        <i className="icofont-twitter" />
                      </Link>
                    </li> */}
                    <li>
                      <Link to="https://www.instagram.com/theolivetreestudioss/?hl=tr">
                        <i className="icofont-instagram" />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.youtube.com/watch?v=zIOt1faGd7g">
                        <i className="icofont-youtube" />
                      </Link>
                    </li>
                  </ul>
                  <Link to="https://www.google.com/maps/dir//The+Olive+Tree+Studios+%C3%96l%C3%BCdeniz+Cumhuriyet+Cd.+No+53+48300+Fethiye%2FMu%C4%9Fla/@36.5716414,29.1305389,14z/data=!4m8!4m7!1m0!1m5!1m1!1s0x14c042d844002779:0x4e0f75f7b6e9e7db!2m2!1d29.1305389!2d36.5716414?entry=ttu" className="btn btn_primary">
                    Get direction <i className="icofont-location-pin" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="gallery_direction_right gallery_slider">
          <Slider className="Slider-Who" {...Whoslider} id="gallery_flow_right" data-aos="fade-in" data-aos-duration={1500} slidesToShow={11.5} arrows={false} autoplay={true} autoplaySpeed={1000}>
            <div className="item">
              <div className="img">
                <img src={gallery01} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery02} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery03} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery04} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery01} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery02} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery03} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery04} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery01} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery02} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery03} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery04} alt="img" />
              </div>
            </div>
          </Slider>
          <Slider className='Slider-Who'{...Whoslider} id="gallery_flow_left" data-aos="fade-in" data-aos-duration={1500}  rtl={true} slidesToShow={11.5} arrows={false} autoplay={true} autoplaySpeed={1000} >
            <div className="item">
              <div className="img">
                <img src={gallery05} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery06} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery07} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery08} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery05} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery06} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery07} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery08} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery05} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery06} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery07} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery08} alt="img" />
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </>
  )
}

export default WhoWe